export default function () {
    document.addEventListener('livewire:init', () => {
        Livewire.on('wishlist-remove', (data) => {
            document.querySelector('.reserved-area-loader').style.display = 'flex';
        });
    });
}
